<template>
  <div class="mainContainer">
    <nav-bar style="width: 100%" :type="-1" :showBtn="false" />

    <div class="innerContainer">
      <div class="editContainer">
        <div class="singleVideoContainer">
          <div style="width: 100%; position: relative">
            <div
              class="coverChangeBtn"
              v-if="previewThumb"
              @click="coverChangeOpen"
            >
              更换封面
            </div>
            <video
              style="height: 100%; height: 430px"
              :src="videoSrc"
              :poster="previewThumb"
              controls
              v-if="videoSrc && !isNewUpload"
            ></video>
            <div class="get-cover" v-if="videoSrc && isNewUpload">
              <p v-if="!previewThumb">视频转码中，可正常提交</p>
              <img
                src="../../assets/videoIcon.png"
                class="videoIcon"
                v-if="previewThumb"
              />
              <img :src="previewThumb" class="videoCover" v-if="previewThumb" />
              <div class="tip" v-if="previewThumb">
                视频转码期间不支持播放，可正常提交
              </div>
            </div>
            <el-upload
              drag
              action="no"
              accept="video/*"
              :before-upload="onBeforeUpload"
              :http-request="uploadFn"
              class="uploadElemBox"
            >
              <p style="color: #333; font-size: 24px">
                <img
                  style="width: 89px; height: 89px"
                  src="../../assets/script/sc.png"
                />
                <br />
                <br />
                <span>点击上传或拖拉至边框内</span>
              </p>
            </el-upload>
          </div>

          <div style="margin-top: 32px">
            <div class="titleLabelContain">
              <p class="titleLabel">作品标题：</p>
            </div>
            <el-input
              style="width: 100%; margin-bottom: 0; margin-right: 0"
              v-model="title"
              placeholder="填写作品标题，为作品获得更多流量"
              clearable
              maxlength="30"
              show-word-limit
            ></el-input>
          </div>

          <div class="contentContain">
            <p class="titleLabel">作品正文：</p>
            <!-- <img
              src="../../assets/topic.png"
              class="topicBtn"
              title="插入话题"
              @click="insertTopic"
            /> -->
          </div>

          <div class="topicListContainer" v-show="topicList.length">
            <div
              v-for="(item, index) in topicList"
              :key="index"
              class="topicList"
              @click="deleteTopic(index)"
            >
              #{{ item }}#
            </div>
          </div>

          <div>
            <el-input
              type="textarea"
              :rows="6"
              placeholder="添加作品简介"
              v-model="content"
              resize="none"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="right">
        <p class="infoLabel">添加到</p>
        <el-select
          v-model="classifyId"
          class="productCheck"
          placeholder="请选择剧目"
          @change="shortPlayChange()"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <p class="infoLabel">设置收费</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer">
            <el-radio
              v-model="needPay"
              label="0"
              :disabled="classifyId == '' ? true : false"
              >限免</el-radio
            >
            <el-radio
              v-model="needPay"
              label="1"
              :disabled="classifyId == '' ? true : false"
              >收费</el-radio
            >
          </div>
        </div>
        <div class="payInfo" v-if="needPay == '1'">
          {{ saleType != "WHOLE" ? "单集" : "全集"
          }}{{ saleType != "WHOLE" ? priceDing : wholePoints }}顶点{{
            assistEnable ? "，3人好友助力可解锁" : ""
          }}
        </div>
        <el-button type="primary" class="submitBtn" @click="submitFn()"
          >发布</el-button
        >
        <el-button type="primary" class="cancelBtn" @click="cancelFn()"
          >取消</el-button
        >
      </div>
    </div>

    <div class="tinymce-upload-progress-box" v-show="isUploading">
      <el-progress
        class="tinymce-upload-progress"
        type="circle"
        :percentage="progressPercent"
      ></el-progress>
    </div>

    <el-dialog
      title="插入话题"
      :visible.sync="insertTopicVisible"
      width="600px"
      class="insertTopicContainer"
    >
      <el-select
        v-model="topicValue"
        filterable
        remote
        default-first-option
        placeholder="请输入或者选择话题"
        :remote-method="getTopicList"
        @change="topicInputChange"
      >
        <el-option
          v-for="item in topicOptions"
          :key="item.id"
          :label="item.title"
          :value="item.id"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 550px;
          "
        >
          <span v-if="item.is_official == 1" style="color: #ea0e0e">(官方)</span
          >{{ item.title }}
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="insertTopicVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertTopicFn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="videoThumbVisible"
      width="1000px"
      class="videoCoverContainer"
    >
      <div class="videoCoverTabs">
        <div
          class="videoCoverTab"
          :class="{ videoCoverTabActive: videoCoverTabIndex == 0 }"
          @click="videoCoverTabIndex = 0"
          v-if="video_id"
        >
          封面截取
        </div>
        <div
          class="videoCoverTab"
          :class="{ videoCoverTabActive: videoCoverTabIndex == 1 }"
          @click="videoCoverTabIndex = 1"
        >
          本地上传
        </div>
      </div>
      <div
        class="videoCutCoverContainer"
        v-if="videoCoverTabIndex == 0"
        v-loading="videoCutCover.length == 0"
        element-loading-text="封面截取中..."
      >
        <div
          class="videoCutCoverBox"
          :class="{ videoCutCoverActive: videoCoverChooseIndex == index }"
          v-for="(item, index) in videoCutCover"
          :key="index"
          @click="videoCoverChooseIndex = index"
        >
          <el-image class="videoCutCover" fit="cover" :src="item"> </el-image>
        </div>
      </div>
      <div class="videoUploadCoverContainer" v-if="videoCoverTabIndex == 1">
        <el-upload
          drag
          action="no"
          accept="image/*"
          :before-upload="onBeforeUploadCover"
          :http-request="uploadCoverFn"
          :show-file-list="false"
          class="uploadVideoCoverBox"
        >
          <img
            src="../../assets/script/sc.png"
            class="uploadIcon"
            v-if="!videoCoverUpload"
          />
          <img
            :src="videoCoverUpload"
            class="videoCoverUpload"
            v-if="videoCoverUpload"
          />
        </el-upload>
        <p class="uploadText">点击上传或拖拉至边框内</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="videoThumbVisible = false">取 消</el-button>
        <el-button type="primary" @click="thumbSubmit">下一步</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="封面剪裁"
      :visible.sync="dialogVisible"
      top="2vh"
      class="thumbCutContainer"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="!isNewCover"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" v-if="!isNewCover"
          >取 消</el-button
        >
        <el-button type="primary" @click="coverCutFinish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "../../components/NavBarForEdit";
import {
  NEWS_HOST,
  SWNEWS_HOST,
  HSUPLOAD_HOST,
  TOPNEWS_HOST,
} from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";
import { VueCropper } from "vue-cropper";

export default {
  data() {
    return {
      id: "",
      title: "",
      content: "",
      videoSrc: "",
      video_id: "",
      progressPercent: 0,
      isUploading: false,
      topicList: [],
      topicIds: [],
      tabActive: 0,
      previewThumb: "",
      getThumbT: "",
      isNewUpload: true,
      insertTopicVisible: false,
      topicOptions: [],
      topicValue: "",
      videoThumbVisible: false,
      videoCoverTabIndex: 0,
      videoCutCover: [],
      videoCoverChooseIndex: -1,
      videoCoverUpload: "",
      dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 900, // 默认生成截图框宽度
        autoCropHeight: 700, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [116, 155], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
        height: false, //是否按照设备的dpr 输出等比例图片
        enlarge: 2, //图片根据截图框输出比例倍数
      },
      isNewCover: false,
      needPay: "0",
      options: [],
      classifyId: "",
      priceDing: 0,
      wholePoints: 0,
      videoDuration: 0,
      saleType: "",
      assistEnable: true,
    };
  },
  components: {
    NavBar,
    VueCropper,
  },
  filters: {},
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    } else {
      this.getList();
    }
  },
  mounted() {},
  methods: {
    getList(seriesId) {
      this.$axios
        .get(
          `${TOPNEWS_HOST}/api/md/series/myList?page=${1}&size=${100}&status=6`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.options = res.data.data.list;

            if (seriesId) {
              this.classifyId = seriesId;

              let has = false;
              this.options.forEach((item) => {
                if (item.id == this.classifyId) {
                  this.priceDing = item.singlePoints;
                  this.wholePoints = item.wholePoints;
                  this.saleType = item.saleType;
                  this.assistEnable = item.assistEnable;
                  has = true;
                }
              });
              if (!has) {
                this.classifyId = "";
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    shortPlayChange() {
      this.options.forEach((item) => {
        if (item.id == this.classifyId) {
          this.priceDing = item.singlePoints;
          this.wholePoints = item.wholePoints;
          this.saleType = item.saleType;
          this.assistEnable = item.assistEnable;
        }
      });
    },
    getDetail() {
      this.$axios
        .get(`${TOPNEWS_HOST}/api/md/drama/myDetail?id=${this.id}`)
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.title;
            this.content = detail.description;
            this.videoSrc = detail.url;
            this.isNewUpload = false;
            this.previewThumb = detail.coverList[0];
            this.video_id = detail.resourceId;
            this.videoDuration = detail.duration;
            this.needPay = detail.chargeEnable ? "1" : "0";

            this.getList(detail.seriesId);

            if (this.video_id) {
              this.getThumbs(this.video_id);
            } else {
              this.videoCoverTabIndex = 1;
            }

            //this.getTopics(detail.global_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    onBeforeUpload(file) {
      const isVIDEO = file.type.indexOf("video/") >= 0;
      if (!isVIDEO) {
        this.$message.error("请上传符合规格的视频格式！");
        return false;
      } else {
        this.uploadProgress(true);
        return true;
      }
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.uploadProgress(false);

          this.videoSrc = data.videoUri;
          this.video_id = data.Vid;
          this.previewThumb = data.PosterUri;
          this.videoCutCover = [];
          this.videoDuration = data.SourceInfo.Duration;

          this.isNewUpload = true;

          this.isNewCover = true;

          this.option.img = this.previewThumb;
          this.dialogVisible = true;

          if (this.$refs.cropper) {
            this.$refs.cropper.reload();
          }

          this.getThumbs(data.Vid);
        },
        (error) => {
          console.log(error);
        },
        (processPercent) => {
          this.progressPercent = Math.floor(processPercent);
        },
        1
      );
    },
    onBeforeUploadCover(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;
      if (!isIMAGE) {
        this.$message.error("请上传图片！");
        return false;
      } else {
        return true;
      }
    },
    uploadCoverFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.videoCoverUpload = data.url;
        },
        (error) => {},
        (processPercent) => {}
      );
    },
    coverChangeOpen() {
      if (this.video_id) {
        this.videoCoverTabIndex = 0;
      }
      this.videoCoverChooseIndex = -1;
      this.videoCoverUpload = this.previewThumb;
      this.option.img = this.previewThumb;
      if (this.$refs.cropper) {
        this.$refs.cropper.reload();
      }
      this.videoThumbVisible = true;
    },
    getThumbs(videoId) {
      this.$axios
        .get(`${HSUPLOAD_HOST}/api/upload/vod/snapshotsList?vid=${videoId}`)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.length != 0) {
              this.videoCutCover = res.data.data;
            } else {
              setTimeout(() => {
                this.getThumbs(videoId);
              }, 1000);
            }
          }
        });
    },
    thumbSubmit() {
      if (this.videoCoverTabIndex == 0) {
        if (this.videoCoverChooseIndex == -1) {
          this.$message({
            showClose: true,
            message: "请选择封面",
            type: "warning",
          });
          return;
        } else {
          this.option.img = this.videoCutCover[this.videoCoverChooseIndex];
        }
      } else {
        if (!this.videoCoverUpload) {
          this.$message({
            showClose: true,
            message: "请上传封面",
            type: "warning",
          });
          return;
        } else {
          this.option.img = this.videoCoverUpload;
        }
      }
      this.videoThumbVisible = false;
      this.dialogVisible = true;
      if (this.$refs.cropper) {
        this.$refs.cropper.reload();
      }
    },
    coverCutFinish() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], "1.jpg", { type: "image/jpeg" });
        HS_upload(
          file,
          (data) => {
            this.isNewCover = false;
            this.dialogVisible = false;
            this.previewThumb = data.url;
          },
          (error) => {
            console.log("error:" + error);
          },
          (processPercent) => {
            console.log("processPercent:" + processPercent);
          }
        );
      });
    },
    uploadProgress(show) {
      let dialog = $(".tinymce-upload-progress-box");
      let progress = $(".tinymce-upload-progress");
      let progressBar = $('<div class="progress-bar"></div>');
      let sourceBox = $(".tinymce-upload-progress-box");
      if (show) {
        this.progressPercent = 0;
        this.isUploading = true;
        progressBar.append(progress);
        dialog.append(progressBar);
        progress.show();
      } else {
        this.isUploading = false;
        progress.hide();
        sourceBox.append(progress);
        progressBar.remove();
      }
    },
    insertTopic() {
      if (this.topicList.length > 2) {
        this.$message({
          message: "最多添加三个话题",
          type: "warning",
        });
        return;
      }
      this.topicValue = "";
      this.getTopicList("");
      this.insertTopicVisible = true;
    },
    getTopicList(keyword) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/search?title=${keyword}&page=1&size=50`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.title = element.title.replace(/#/gi, "");
              if (element.id == 0) {
                element.title += "--点击添加新话题";
                element.id = element.title;
              }
            });
            this.topicOptions = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topicInputChange(val) {
      if (typeof this.topicValue == "string") {
        this.topicValue = this.topicValue.replace(/--点击添加新话题/gi, "");
      }
    },
    insertTopicFn() {
      if (typeof this.topicValue == "string" && this.topicValue == "") {
        this.$message({
          message: "话题不能为空",
          type: "warning",
        });
      } else if (typeof this.topicValue == "string") {
        if (this.topicValue.length > 30) {
          this.$message({
            message: "话题长度不能超过30个字",
            type: "warning",
          });
          return;
        }
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/add`, {
            title: "#" + this.topicValue + "#",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.checkTopic(res.data.data.id)) {
                this.$message({
                  message: "不能添加重复话题",
                  type: "warning",
                });
              } else {
                this.topicList.push(this.topicValue);
                this.topicIds.push(res.data.data.id);
                this.insertTopicVisible = false;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.checkTopic(this.topicValue)) {
        this.$message({
          message: "不能添加重复话题",
          type: "warning",
        });
      } else {
        this.topicOptions.forEach((item) => {
          if (item.id == this.topicValue) {
            this.topicList.push(item.title.replace(/#/gi, ""));
            this.topicIds.push(this.topicValue);
            this.insertTopicVisible = false;
          }
        });
      }
    },
    checkTopic(id) {
      return this.topicIds.indexOf(id) > -1;
    },
    deleteTopic(index) {
      this.$confirm("确定要删除该话题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.topicList.splice(index, 1);
          this.topicIds.splice(index, 1);
        })
        .catch(() => {});
    },
    getTopics(global_id) {
      this.$axios
        .get(
          `${NEWS_HOST}/api/hottopic/getTopicListByManuscriptId?global_id=${global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item) => {
              this.topicList.push(item.title.replace(/#/gi, ""));
              this.topicIds.push(item.id);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    submitFn() {
      if (this.title == "") {
        this.$message({
          message: "请输入作品标题",
          type: "warning",
        });
      } else if (this.video_id == "") {
        this.$message({
          message: "请上传视频",
          type: "warning",
        });
      } else if (this.classifyId == "") {
        this.$message({
          message: "请选择剧目",
          type: "warning",
        });
      } else {
        this.$axios
          .post(`${TOPNEWS_HOST}/api/md/drama/save`, {
            id: this.id,
            title: this.title,
            description: this.content,
            url: this.videoSrc,
            resourceId: this.video_id,
            seriesId: this.classifyId ? this.classifyId : 0,
            topicIds: this.topicIds,
            cover: JSON.stringify([this.previewThumb]),
            chargeEnable: this.needPay == 1 ? true : false,
            duration: this.videoDuration,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: `发布成功`,
                type: "warning",
              });
              this.$router.push({
                path: "/shortPlay",
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    cancelFn() {
      this.$router.back();
    },
  },
};
</script>

<style>
.el-tabs__nav-scroll {
  display: flex;
}

.el-tabs__nav-wrap::after {
  background: white;
}
.el-tabs__item.is-active {
  color: #333;
  font-weight: bold;
}
.el-input--suffix .el-input__inner {
  background: #f6f7f9;
  border: 0px;
}
.el-textarea__inner {
  background: #f6f7f9;
  border: 0px;
}
</style>

<style lang="scss" scoped>
.mainContainer {
  background: #edf1f8;
  box-sizing: border-box;

  .innerContainer {
    display: flex;
    height: 100%;
    justify-content: space-between;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background: #edf1f8;
    min-height: calc(100vh - 84px);

    /deep/.editContainer {
      margin: 20px auto 0 auto;
      background: white;
      border-radius: 8px 8px 0 0;
      position: relative;
      width: 900px;

      .singleVideoContainer {
        padding: 60px 80px 30px 80px;

        .videoContainer {
          position: relative;
        }

        .coverChangeBtn {
          cursor: pointer;
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 14px;
          width: 88px;
          line-height: 32px;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-align: center;
          z-index: 1;
        }

        .get-cover {
          width: 100%;
          height: 430px;
          border: 1px solid #e8e8e8;
          background-color: #fcfcfc;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          position: relative;
        }
        .get-cover p {
          width: 100%;
          height: 24px;
          text-align: center;
          color: #bbb;
          margin-top: 0 !important;
          font-size: 18px;
        }
        .get-cover .tip {
          position: absolute;
          left: 0;
          bottom: -1px;
          font-size: 12px !important;
          color: #fff;
          width: 100%;
          line-height: 32px !important;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.32);
          border-radius: 4px;
        }
        .get-cover .videoIcon {
          width: 40px;
          height: 40px;
          min-height: 40px;
          position: absolute;
          left: 50%;
          top: 50%;
          margin: -20px 0 0 -20px !important;
        }
        .get-cover .videoCover {
          height: 100%;
          object-fit: cover;
        }

        .titleLabelContain {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .titleLabel {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }

          .titleAiOutBtn {
            cursor: pointer;
            background-color: #ffffff;
            color: #165dff;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }

          .titleAiBtn {
            padding: 0;
            border: 0;
          }
        }
        .contentContain {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 12px;
          margin-top: 32px;

          .titleLabel {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }

          .topicBtn {
            width: 21px;
            cursor: pointer;
          }
        }
      }

      .el-textarea {
        margin: 0 0 10px 0;
      }

      .el-tabs {
        height: calc(100% - 275px);
      }

      .el-tabs__content {
        height: 100%;
      }

      video {
        width: 100%;
        margin-bottom: 20px;
      }

      .uploadElemBox {
        width: 100%;
        height: 328px;

        .el-upload {
          /* background: #e2e2e2; */
          width: 100%;
          height: 100%;

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            //视频上传，这里需要加一个图标
            background: #f6f7f9;
            border: 1px solid #e2e2e2;

            p {
              font-size: 20px;
              color: #409eff;
              width: 100%;
              text-align: center;
            }
          }
        }

        .el-upload-list {
          display: none;
        }
      }

      .el-input__count,
      .el-input__count-inner {
        background-color: #f6f7f9;
      }
    }

    .topicListContainer {
      display: flex;
      flex-wrap: wrap;
      margin: 0 0 10px 0;

      .topicList {
        margin-right: 20px;
        font-size: 14px;
        color: #1687d9;
        cursor: pointer;
      }
    }

    .right {
      width: 330px;
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 32px;
      margin-top: 1px;
      background: white;

      .infoLabel {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 12px;
      }

      .radioContainer {
        margin-bottom: 8px;
      }

      .productCheck {
        width: 100%;
        margin: 0 0 10px 0;

        /deep/.el-input__inner {
          padding-left: 20px;
          border-radius: 4px;
          background: #f6f7f9;
          border: 0;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
        }
      }

      .payInfo {
        color: #999999;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }

      .submitBtn {
        width: 100%;
        height: 36px;
        padding: 0;
        margin: 0;
        margin-top: 50px;
      }

      .cancelBtn {
        width: 100%;
        height: 36px;
        padding: 0;
        margin: 0;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #ccc;
        color: #333333;
        margin-top: 15px;
      }
    }
  }

  /deep/.insertTopicContainer {
    .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
    }
    .el-select {
      width: 100%;
    }
    .el-input {
      width: 100%;
      margin-bottom: 0;
    }
    .el-input__inner {
      width: 100%;
    }
  }

  /deep/.videoCoverContainer {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0 0 0 0;

      .videoCoverTabs {
        display: flex;
        border-bottom: 1px solid #ebebeb;

        .videoCoverTab {
          cursor: pointer;
          margin-left: 28px;
          font-weight: normal;
          color: #161616;
          line-height: 64px;
          font-size: 18px;
        }
      }

      .videoCoverTabActive {
        border-bottom: 3px solid #fd595c;
      }

      .videoCutCoverContainer {
        height: 50vh;
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 0 28px;

        .videoCutCoverBox {
          padding: 2px;
          width: 212px;
          margin: 28px 28px 0 0;
          cursor: pointer;
          border: 2px solid #ffffff;

          .el-image {
            display: block;
          }
        }

        .videoCutCoverActive {
          border: 2px solid #ea0e0e;
        }
      }

      .videoUploadCoverContainer {
        height: 50vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .uploadText {
          font-size: 16px;
          margin-top: 20px;
        }

        .uploadVideoCoverBox {
          width: 500px;
          height: 281px;

          .el-upload {
            width: 100%;
            height: 100%;
          }

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .uploadIcon {
              height: 89px;
            }

            .videoCoverUpload {
              max-height: 100%;
              max-width: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    .el-dialog__footer {
      padding-top: 20px;
    }
  }

  .thumbCutContainer {
    /deep/.el-dialog__body {
      padding-bottom: 10px;
      padding-top: 0;

      .avatar-uploader {
        background: red !important;
        width: 150px;
        height: 150px;
        text-align: center;
        line-height: 150px;
      }

      .el-icon-plus {
        width: 150px;
        height: 150px;
        font-size: 30px;
      }

      .cropper-content {
        width: 100%;
        height: 700px;
        background: pink;
      }

      .cropper {
        width: 100%;
        height: 700px;
        background: yellow;
      }

      .cropper-modal {
        background: rgba(0, 0, 0, 0.2) !important;
      }

      .cropper-view-box {
        img {
          display: none;
        }
      }
    }
  }
}

.tinymce-upload-progress-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 10000;
}

/deep/.tinymce-upload-progress {
  z-index: 10001;
}

.tinymce-upload-progress {
  position: absolute !important;
  text-align: center;
  display: none;
  top: 50%;
  left: 50%;
  margin-top: -62px !important;
  margin-left: -60px !important;
}
</style>
